/**
 * The agent API paths the Copilot composers below agent sessions call directly.
 *
 * They live here rather than in the full agent-sessions URL helper because the
 * composer resolves environments and repositories before any session exists,
 * and the rest of that helper is keyed by session, task and artifact shapes it
 * has no reason to reach for.
 */

/**
 * Generates the API path for the environments endpoint with optional filters.
 * Used by the Mission Control Environments API (gated behind
 * `copilot_mission_control_environments_web_kickoff`).
 * @param params - Optional filters: `kind` and/or `status`
 * @returns API path for the environments endpoint with query string
 */
export function environmentsApiPath(params?: {kind?: string; status?: string}): string {
  const basePath = `/agents/environments`
  const searchParams = new URLSearchParams()
  if (params?.kind !== undefined) {
    searchParams.set('kind', params.kind)
  }
  if (params?.status !== undefined) {
    searchParams.set('status', params.status)
  }
  const query = searchParams.toString()
  return query ? `${basePath}?${query}` : basePath
}

/**
 * Generates the path for fetching a repository's details from the Copilot chat
 * API. This endpoint is served by the github.com monolith rather than the CMC
 * (CAPI) service.
 * @param repoID - The repository ID or owner/name to fetch
 * @returns Path for the Copilot chat repository endpoint
 */
export function copilotChatRepositoryPath(repoID: number | string): string {
  return `/github-copilot/chat/repositories/${String(repoID).split('/').map(encodeURIComponent).join('/')}`
}
